const Inputwithlable = ({
  className,
  type,
  value,
  name,
  id,
  placeHolder,
  handleChange,
  error,
  labelName,
  lableclassName,
  showastrict=false,
  disable = false,
  maxlng=""
}) => {
  return (
    <div>
      <div className="input-container">
        <label className={lableclassName}>
          {labelName} {showastrict && <span className="text-danger">*</span>}
        </label>
        <input
          required
          type={type}
          name={name}
          value={value}
          className={`form-control p-0 ${className}  ${error ? "border-danger bg-error" : ""}`}
          placeholder={placeHolder}
          onChange={handleChange} 
          disabled={disable}
          maxLength={maxlng}
        />
      </div>
    </div>
  );
};

export default Inputwithlable;
